import type { KnowledgeItem } from '@/types';

// 盾构机 TBM 隧道掘进知识库（15 条）
export const tbmKnowledge: KnowledgeItem[] = [
  // ========== 工艺基础 ==========
  {
    id: 'TBM-K001',
    tags: ['盾构机', '工艺', '基础'],
    question: '盾构机掘进的基本原理是什么？',
    answer: '盾构机是一种隧道掘进专用机械：前端刀盘旋转切削土体/岩体，切削下来的渣土进入土仓（泥水仓），经螺旋输送机排出；盾体（前盾+中盾+尾盾）保护已挖隧道，尾部拼装预制管片形成永久衬砌；同步注浆填充管片与土体间空隙。整个过程在密封环境下进行，不影响地表交通。',
  },
  {
    id: 'TBM-K002',
    tags: ['刀盘', '转速', '关键参数'],
    question: '刀盘转速一般控制在多少？',
    answer: '刀盘转速通常 1~2 r/min（硬岩可到 3）。转速越高切削越快但扭矩和磨损也大：①软土层 1.0~1.5 r/min ②风化岩 1.5~2.0 r/min ③硬岩 2.0~3.0 r/min。扭矩超过 5500 kN·m 必须降速检查刀具磨损。',
  },
  {
    id: 'TBM-K003',
    tags: ['推进速度', '关键参数'],
    question: '推进速度怎么确定？',
    answer: '推进速度 15~35 mm/min 为正常区间。速度过低（<10）效率差且刀盘易空转发热；过高（>40）推力飙升、磨损加剧、姿态难控。遇到硬岩段应降到 5~10 mm/min 并配合换刀；软土段可到 30~35。',
  },
  {
    id: 'TBM-K004',
    tags: ['土仓压力', '泥水仓', '关键参数'],
    question: '泥水仓压力为什么重要？',
    answer: '仓压必须 ≥ 地下水位 + 0.2 bar 安全余量，一般 1.5~3.5 bar。压力过低→地下水涌入、地层流失、地表沉降；压力过高→地表隆起、泥浆窜出。用泥浆密度（1.18~1.35 g/cm³）和进排浆流量差来维持仓压稳定。',
  },
  {
    id: 'TBM-K005',
    tags: ['同步注浆', '关键参数'],
    question: '同步注浆的作用和参数？',
    answer: '管片拼装后与土体之间有 10~15cm 空隙，必须同步注浆填充。注浆量 = 理论空隙的 100~130%（过充填 0~30%）。注浆压力 0.25~0.45 MPa。注浆不足→地表沉降；过量→管片上浮、地表隆起。',
  },

  // ========== 典型故障处理 ==========
  {
    id: 'TBM-K101',
    tags: ['刀具磨损', '故障', '换刀'],
    question: '刀具磨损超过 75% 怎么处理？',
    answer: '磨损 > 75% 进入危险区，切削效率骤降、扭矩飙升。正确操作：①立即降低推进速度到 5 mm/min ②降低刀盘转速减少冲击 ③进入泥水保压模式准备换刀 ④绝对不能强行提推力穿岩——会导致刀圈崩裂、刀盘变形。换刀在保压状态下进行，仓压不能低于地下水 +0.2 bar。',
  },
  {
    id: 'TBM-K102',
    tags: ['地层涌水', '故障', '仓压'],
    question: '土仓压力突降、盾尾冒水怎么办？',
    answer: '仓压 < 1.5 bar 且盾尾密封压力下降，说明地层涌水风险。正确操作：①紧急提高泥浆密度到 1.30 g/cm³ 建立压力 ②加大同步注浆量到 130% 填充空隙 ③降低推进速度减少地层扰动 ④绝不能加速冲过砂层——会加剧地层流失。持续监测地表沉降，>15mm 要考虑停机注浆。',
  },
  {
    id: 'TBM-K103',
    tags: ['姿态偏差', '故障', '纠偏'],
    question: '盾构姿态偏差超过 50mm 怎么纠偏？',
    answer: 'X/Y 偏差 > 50mm 说明推力不均。正确操作：①先降低推进速度等姿态稳定 ②分组调整 16 组推进油缸推力比例（偏哪边就减小那边）③滚动角 > 2° 用纠偏千斤顶反向调 ④绝不能加大总推力强行修正——会让管片错台更严重。纠偏速率 ≤ 5mm/环，避免急纠导致管片开裂。',
  },
  {
    id: 'TBM-K104',
    tags: ['地表沉降', '监测'],
    question: '地表沉降超标的原因和预防？',
    answer: '沉降 > 10mm 触发预警，> 20mm 必须停机。原因：①注浆量不足（< 100% 理论空隙）②仓压波动导致地层扰动 ③推进速度过快。处理：加大注浆量到 130%+、稳住仓压、降推进速度。地表设 5 个监测点，M1~M5 沿隧道轴线布置，每环记录。',
  },
  {
    id: 'TBM-K105',
    tags: ['螺旋输送机', '出土'],
    question: '螺旋转速和出土量怎么配？',
    answer: '螺旋转速 5~15 r/min，出土量应为理论值的 95~110%。转速过低→渣土堆积、仓压升高；过高→出土过快、仓压骤降。原则：螺旋出土量 = 掘进进尺对应的土体体积，保持动态平衡。螺旋转速应跟随刀盘转速联动调节。',
  },

  // ========== 设备维护 ==========
  {
    id: 'TBM-K201',
    tags: ['主驱动', '振动', '维护'],
    question: '主驱动振动值超标怎么判断？',
    answer: '振动 > 4.5 mm/s 需关注，> 6 mm/s 必须降速检查。原因：①刀盘不平衡（刀具磨损不均）②主轴承间隙增大 ③齿轮箱磨损。先降刀盘转速到 1.0 以下观察，如果振动仍不降，停机检查主轴承润滑和齿轮啮合。',
  },
  {
    id: 'TBM-K202',
    tags: ['盾尾密封', '维护'],
    question: '盾尾密封压力为什么要保持？',
    answer: '盾尾密封压力 0.4~0.7 MPa，用油脂（3~8 kg/h）形成密封环。压力过低→泥水从盾尾窜入隧道；过高→油脂浪费、管片被推偏。密封压力应跟随仓压联动：仓压每升 1 bar，密封压力加 0.15 MPa。',
  },
  {
    id: 'TBM-K203',
    tags: ['管片拼装', '精度'],
    question: '管片拼装精度怎么保证？',
    answer: '拼装精度 ≤ 5mm 为合格。关键点：①抓取力 280~380 kN 确保不滑落 ②拼装前清理环面 ③定位时先粗调再微调 ④盾构姿态偏差大时拼装精度必然差——先纠姿态再拼装。精度 > 8mm 会导致管片错台、渗水。',
  },

  // ========== 高级操作 ==========
  {
    id: 'TBM-K301',
    tags: ['泥水保压', '换刀'],
    question: '泥水保压换刀模式的操作要点？',
    answer: '刀具磨损需更换时，在泥水保压模式下操作：①停止推进、刀盘停转 ②保持仓压 ≥ 地下水 +0.2 bar ③泥浆密度提到 1.30~1.35 ④人员通过人闸进入土仓 ⑤换刀期间持续监测仓压，压力降立即补浆。整个过程通常 4~8 小时。',
  },
  {
    id: 'TBM-K302',
    tags: ['硬岩段', '掘进参数'],
    question: '硬岩段掘进参数怎么调？',
    answer: '硬岩段（单轴抗压 > 60 MPa）参数策略：①刀盘转速 2~3 r/min 提高线速度 ②推进速度 5~15 mm/min 比软土慢 ③推力可能到 25000~30000 kN ④密切监控刀具温度（< 120°C）和磨损（< 75%）⑤每 20~30 环检查一次刀具。硬岩段是刀具消耗最大的工况。',
  },
];
